import { Injectable, signal } from '@angular/core';
import { DialogService } from 'src/app/core/dialogs/dialog.service';
import { AuthenticationService } from '../providers';
import { UserInfo } from '../models';
import { SelectableClient } from '../models/selectable-client';
import { TYPE as CompetitiveDisclaimerType } from './competitive-disclaimer-dialog.component';
import { takeWhile } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class CompetitiveDisclaimerService {
  private initialized = signal(false);
  constructor(
    private dialogService: DialogService, // injects the dialog service to register the competitive disclaimer dialog
    private authenticationService: AuthenticationService
  ) {}

  init(): void {
    this.authenticationService.userInfoSubject
      .pipe(takeWhile((value) => !this.initialized()))
      .subscribe((result: UserInfo | null) => {
        if (result) {
          const client: SelectableClient =
            this.authenticationService.userInfoView?.SelectedClient;
          this.initialized.set(true);
          if (
            client.RequiresMQACompetitionDisclaimer !== undefined &&
            client.RequiresMQACompetitionDisclaimer === true
          ) {
            this.dialogService.openDialog(CompetitiveDisclaimerType);
          }
        }
      });
  }
}
